import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/base/SEOMeta';
import HeroBanner from './components/HeroBanner';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '里番动漫精选推荐',
    url: 'https://your-site.com/',
    description: '探索里番动漫的完整世界，精选热门里番动漫作品、分类推荐、观看渠道及资讯。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://your-site.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '里番动漫精选',
    url: 'https://your-site.com/',
    description: '专业的里番动漫推荐与观看指南平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@example.com',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <SEOMeta
        title="首页"
        description="探索里番动漫的完整世界，本页为您精选热门里番动漫作品、分类推荐、观看渠道及相关资讯，帮助成人动漫爱好者快速找到优质里番动漫内容，了解里番动漫文化背景与发展历史。"
        keywords="里番动漫,里番动漫推荐,里番动漫在线观看,成人动漫,里番动漫排行榜,日本里番动漫,里番动漫合集"
        canonicalUrl="https://your-site.com/"
        ogType="website"
      />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
      </main>
      <Footer />
    </>
  );
}